import React from 'react'
import { Route } from 'react-router-dom';
// import MainTasksPlan from '../Views/Web/Project/SubMenu/Tasks/Plan/main';
import MainTasks from '../Views/Web/Project/SubMenu/Tasks/MainTask';
import MainTasksPlan from '../Views/Web/Project/SubMenu/Tasks/Plan/main';
import TaskPlan from '../Views/Web/Project/SubMenu/Tasks/Plan';
import CreateTask from '../Views/Web/Project/SubMenu/Tasks/Components/createTask';
import ViewTask from '../Views/Web/Project/SubMenu/Tasks/Components/viewTask';
import MainTaskSchedule from '../Views/Web/Project/SubMenu/Tasks/Schedule/main';
import TaskSchedule from '../Views/Web/Project/SubMenu/Tasks/Schedule';
import EditTask from '../Views/Web/Project/SubMenu/Tasks/Components/editTask';

function ProjectPlaningRoutes() {
  return (
<Route path="main-taskplan" element={<MainTasks/>}>
<Route path='main-task-plan/:officeId/:projectId' element={<MainTasksPlan/>}>
<Route index element={<TaskPlan/>} />
     <Route path="create" element={<CreateTask/>} />
     <Route path="view/:taskViewId" element={<ViewTask />} />
     <Route path="edit/:taskEditId" element={<EditTask />} />

     
</Route>
<Route path="task-schedule/:officeId/:projectId" element={<MainTaskSchedule />}>
     <Route index element={<TaskSchedule/>} />
    </Route>
</Route>
)
}

export default ProjectPlaningRoutes;
